import en from '../../locales/en.json';
import de from '../../locales/de.json';
import nl from '../../locales/nl.json';
import nl_be from '../../locales/nl-be.json';
import cs from '../../locales/cs.json';
import pl from '../../locales/pl.json';
import fr from '../../locales/fr.json';

import store from '../store/index';

const translations = {
    en,
    de,
    nl,
    'nl-be': nl_be,
    cs,
    pl,
    fr,
};

const interpolate = (key, kwargs) =>
    key.replace(/{(\w+)}/g, function (_, placeholder) {
        return kwargs[placeholder];
    });

const normalizeTranslationKey = key => {
    let normalized = `${key || ''}`;
    if (normalized && !normalized.includes(' {') && !normalized.includes('({') && !normalized.includes('})')) {
        normalized = normalized.replace('{', ' {').replace('}', '} ');
    }
    return normalized;
};

const getLanguageCode = () => {
    const code = store?.state?.auth?.user?.lang?.code || 'en';
    return `${code}`.replace('_', '-').toLowerCase();
};

export const translateKey = (key, kwargs) => {
    const normalizedKey = normalizeTranslationKey(key);
    const languageCode = getLanguageCode();
    const languageTranslations = translations[languageCode] || translations.en || {};

    if (languageTranslations[normalizedKey]) {
        const translatedValue = languageTranslations[normalizedKey];
        return kwargs ? interpolate(translatedValue, kwargs) : translatedValue;
    }

    return kwargs ? interpolate(normalizedKey, kwargs) : normalizedKey;
};

export default {
    install: app => {
        app.config.globalProperties.$__ = translateKey;
    },
};
